module.exports = __webpack_public_path__ + "img/FR.94dc90e2.svg";